import { useQuery } from '@tanstack/react-query'
import { getAlert } from '../api'

export const alertDetailQueryKey = (id: string) => ['alerts', 'detail', id] as const

export function useAlertDetail(id: string | undefined) {
  return useQuery({
    queryKey: ['alerts', 'detail', id ?? ''] as const,
    queryFn: () => getAlert(id!),
    enabled: id !== undefined && id !== '',
    staleTime: 30_000,
  })
}
